<ul class="nav navbar-nav side-menu" id="sidebarnav">

  <li routerLink="/Dashboard" routerLinkActive="Active">
    <a href="javascript:void(0);"  >
      <div class="pull-left"><i class="ti-home"></i><span class="right-nav-text">Dashboard</span></div>
      <div class="pull-right"></div><div class="clearfix"></div>
    </a>
  </li>

  <ng-container *ngFor="let menuLvl1 of Data_Menu">
    <li  (click)="Change_Visible_Menu(menuLvl1)" style="cursor: pointer;" class="mt-10 mb-10 text-muted pl-4 font-medium menu-title">
      {{menuLvl1.title}}

      <div [hidden]="menuLvl1.count==0" class="pull-left badge-info"><i class="fa fa-list"></i></div>
      <div [hidden]="menuLvl1.count>0" class="pull-left"><i class="fa fa-list"></i></div>
    </li>


    <li [hidden]="!menuLvl1.visible" *ngFor="let menuLvl2 of menuLvl1.child" [routerLink]="menuLvl2.link" routerLinkActive="Active" >

      <a href="javascript:void(0);" *ngIf="menuLvl2.parent>0" (click)="Set_Count_Zero(menuLvl2)" >
          <div class="pull-left"><i class="{{menuLvl2.icon}}"></i><span class="right-nav-text">{{menuLvl2.title}}</span></div>
          <span *ngIf="menuLvl2.count>0" class="badge badge-pill badge-danger float-right mt-1">{{menuLvl2.count}}</span>
          <span *ngIf="menuLvl2.new>0" class="badge badge-pill badge-info float-right mt-1">New {{menuLvl2.new}} </span>
          <div class="pull-right"></div><div class="clearfix"></div>
        </a>

    </li>

  </ng-container>


</ul>
